export function PaginateFilter() {
    return function (input, pageNumber, pageSize) {
        const start = (pageNumber - 1) * pageSize;
        const end = pageNumber * pageSize;
        if (isNaN(start) || isNaN(end)) {
            // Don't error, but warn and default to including the full results instead.
            console.warn("Invalid page number or page size");
        }
        return input && input.slice(start || 0, end || undefined);
    };
}
